// GenericIcon.jsx

import React from 'react';

/**
 * GenericIcon
 *
 * @returns {ReactNode} The rendered component.
 */
const GenericIcon = React.memo(({ width = 24, height = 24, ...rest }) => {

  // ----- RENDER ----- //

  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      style={{
        opacity: 0.2,
      }}
      d="M 14.5,8 C 13.115,8 12,9.115 12,10.5 v 45 c 0,1.385 1.115,2.5 2.5,2.5 h 35 C 50.885,58 52,56.885 52,55.5 V 23 L 38.25,21.75 37,8 Z"
    />
    <path fill="#e4e4e4" d="m14.5 7c-1.385 0-2.5 1.115-2.5 2.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5v-32.5l-13.75-1.25-1.25-13.75z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="m 37,8 v 12.5 c 0,1.3808 1.1193,2.5 2.5,2.5 H 52 Z"
    />
    <path fill="#fafafa" d="m37 7v12.5c0 1.3808 1.1193 2.5 2.5 2.5h12.5l-15-15z" />
    <path
      style={{
        fill: '#ffffff',
        opacity: 0.2,
      }}
      d="M 14.5,7 C 13.115,7 12,8.115 12,9.5 v 1 C 12,9.115 13.115,8 14.5,8 H 37 c 0,-1 0,0 0,-1 z"
    />
  </svg>
  );
});

// Dev Tools
GenericIcon.displayName = 'GenericIcon';

export default GenericIcon;
